import { useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import NewCatModal from './NewCatModal';
import axios from '../../../axios';
import NoPermissions from '../../NoPermissions/NoPermissions';
import ProdCatModal from './ProdCatModal';
import usePermisos from '../../../hooks/usePermisos';
import { Table, TableSwitch, useTableSort } from '../../UI';


const PERMISOS_REQUERIDOS = [
    'categories_create',
    'categories_read',
    'categories_update',
    'categories_delete',
    'products_btn_read_category'
];

const Categorias = () => {
    const { permisos, loading: loadingPermisos, tienePermiso } = usePermisos(PERMISOS_REQUERIDOS);
    const [catServicios, setCatServicios] = useState([]);
    const [catServiciosRaw, setCatServiciosRaw] = useState([]);
    const [catSelected, setCatSelected] = useState(null);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState({});
    const [catToUpdate, setCatToUpdate] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [loader, setLoader] = useState(true);
    const [modalProductosOpen, setModalProductosOpen] = useState(false);
    const [modalCategoriaOpen, setModalCategoriaOpen] = useState(false);

    useEffect(() => {
        axios.get('api/categories')
            .then(res => {
                setCatServicios(res.data);
                setCatServiciosRaw(res.data);
                setLoader(false);
            })
            .catch(e => {
                console.log("error ", e);
                setLoader(false);
            });
    }, []);


    useEffect(() => {
        if (catToUpdate.id) {
            axios.post(`api/category/${catToUpdate.id}`, catToUpdate)
                .then(resp => {
                    if (resp.status === 200) {
                        setCatServicios(catServicios.map((item) => {
                            if (item.id === resp.data.id) return resp.data;
                            return item;
                        }));
                        setCatServiciosRaw(catServiciosRaw.map((item) => {
                            if (item.id === resp.data.id) return resp.data;
                            return item;
                        }));
                        alert('Categoría actualizada correctamente');
                    }
                })
                .catch(e => console.log("Error: ", e));
        }
    }, [catToUpdate, catToUpdate.activo]);

    const _handlerModal = (categoria) => {
        setCategoriaSeleccionada(categoria);
        setModalCategoriaOpen(true);
    };

    const _delete = (categoria) => {
        if (window.confirm("Realmente deseas borrar a esta categoría, si la borras no se podra recuperar despues")) {
            axios.delete(`api/categories/${categoria.id}`)
                .then(res => {
                    alert(res.data.message);
                    setCatServicios(catServicios.filter(u => u.id !== res.data.categoria.id));
                    setCatServiciosRaw(catServiciosRaw.filter(u => u.id !== res.data.categoria.id));
                })
                .catch(e => console.log("error", e));
        }
    };

    const OpenModalProductos = (catId) => {
        setCatSelected(catId);
        setModalProductosOpen(true);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);

        if (value.length > 2) {
            const filtered = catServiciosRaw.filter(cat =>
                cat.nombre_categoria.toLowerCase().includes(value)
            );
            setCatServicios(filtered);
        } else if (value.length === 0) {
            setCatServicios(catServiciosRaw);
        }
    };

    const handleResetFilters = () => {
        setSearchTerm('');
        setCatServicios(catServiciosRaw);
    };

    const _handleChecked = (newValue, categoria) => {
        let updatedCat = { ...categoria, activo: newValue ? 1 : 0 };
        setCatToUpdate(updatedCat);
    };

    // Hook de ordenamiento
    const { sortedData, sortConfig, handleSort } = useTableSort(catServicios, { 
        field: 'id', 
        direction: 'ASC' 
    });

    // Columnas para la tabla
    const columns = [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'nombre_categoria', label: 'Nombre Categoria', sortable: true },
        { key: 'description', label: 'Descripción' },
        {
            key: 'productos',
            label: 'Productos',
            render: (_, row) => (
                <button
                    className="px-4 py-2 text-sm font-medium text-white bg-[#11cdef] rounded hover:bg-[#0fa5c7] transition-colors"
                    onClick={() => OpenModalProductos(row.id)}
                >
                    Ver Productos
                </button>
            ),
        },
        {
            key: 'activo',
            label: 'Activo',
            align: 'center',
            render: (value, row) => (
                tienePermiso('products_btn_read_category') ? (
                    <TableSwitch
                        value={value}
                        onChange={(newValue) => _handleChecked(newValue, row)}
                        row={row}
                        activeColor="#11cdef"
                        size="sm"
                    />
                ) : null
            ),
        },
    ];

    // Acciones para la tabla
    const actions = [
        {
            type: 'edit',
            onClick: _handlerModal,
            tooltip: 'Editar',
            permission: 'categories_update',
        },
        {
            type: 'delete',
            onClick: _delete,
            tooltip: 'Eliminar',
            permission: 'categories_delete',
        },
    ];

    if (loadingPermisos) {
        return (
            <div>
                <div className='container-admin-menu'>
                    <Breadcrumb hasModalButton={''} hasFilters={false} />
                </div>
                <div className='container-admin-container'>
                    <div className='container-admin z-depth-1 p-4'>
                        <div className="flex justify-center py-10">
                            <span className="text-gray-500">Cargando...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!tienePermiso('categories_read')) {
        return (
            <div>
                <div className='container-admin-menu'>
                    <Breadcrumb 
                        hasModalButton={tienePermiso('categories_create') ? 'categorias-modal' : ''} 
                        hasFilters={false}
                        onModalClick={() => {
                            setCategoriaSeleccionada({});
                            setModalCategoriaOpen(true);
                        }}
                    />
                </div>
                <div className='container-admin-container'>
                    <div className='container-admin z-depth-1'>
                        <NoPermissions />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='container-admin-menu'>
                <Breadcrumb 
                    hasModalButton={tienePermiso('categories_create') ? 'categorias-modal' : ''} 
                    hasFilters={false}
                    onModalClick={() => {
                        setCategoriaSeleccionada({});
                        setModalCategoriaOpen(true);
                    }}
                />
            </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 p-4'>
                    <NewCatModal
                        isOpen={modalCategoriaOpen}
                        onClose={() => {
                            setModalCategoriaOpen(false);
                            setCategoriaSeleccionada({});
                        }}
                        categoriaSeleccionada={categoriaSeleccionada}
                        setCategoriaSeleccionada={setCategoriaSeleccionada}
                        catServicios={catServicios}
                        setCatServicios={setCatServicios}
                        catServiciosRaw={catServiciosRaw}
                        setCatServiciosRaw={setCatServiciosRaw}
                    />

                    {/* Barra de búsqueda */}
                    <div className="info-badge rounded-xl p-3 mb-4 flex flex-col md:flex-row items-center gap-3">
                        <div className="flex items-center gap-2">
                            <img
                                className="w-8 h-8"
                                src="/images/pacientes.png"
                                alt="Categorías"
                            />
                            <span className="text-white font-medium text-sm">Buscar:</span>
                        </div>

                        <div className="flex-1 flex items-center gap-2">
                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    className="w-full px-4 py-2 pr-10 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                    placeholder="Buscar por nombre de categoría..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <svg
                                    className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>

                            {searchTerm && (
                                <button
                                    onClick={handleResetFilters}
                                    className="px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium flex items-center gap-1"
                                    title="Limpiar búsqueda"
                                >
                                    <img src="/images/clear-filters.png" alt="Limpiar" className="w-4 h-4" />
                                    Limpiar
                                </button>
                            )}
                        </div>
                    </div>

                    <Table
                        columns={columns}
                        data={sortedData}
                        actions={actions}
                        permissions={permisos}
                        loading={loader}
                        striped={true}
                        hoverable={true}
                        emptyMessage="No hay categorías registradas"
                        sorting={{
                            field: sortConfig.field,
                            direction: sortConfig.direction,
                            onSort: handleSort
                        }}
                    />

                    <ProdCatModal
                        isOpen={modalProductosOpen}
                        onClose={() => {
                            setModalProductosOpen(false);
                            setCatSelected(null);
                        }}
                        catSelected={catSelected}
                    />
                </div>
            </div>
        </>
    );
};

export default Categorias;